// extracted by mini-css-extract-plugin
export default {"input":"CustomPhaseInput_input__Do2Hs"};